/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/

import React, { useState, useEffect } from 'react';
import './Renderer.scss';
import {Suspense, useMemo, useRef} from 'react';
import { Canvas, useLoader, useFrame } from "@react-three/fiber";
import { Html, OrbitControls, PerspectiveCamera, OrthographicCamera } from "@react-three/drei";
import { DepthOfField, EffectComposer } from '@react-three/postprocessing'
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader'
import * as THREE from 'three'
import SystemConfiguration from "settings/SystemConfiguration"
import Axis from "rendering/Axis"
// import SceneProperties from 'settings/SceneProperties';
import { useProgress } from '@react-three/drei'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'

import Mesh from "rendering/Mesh"



/*-----------------------------------------------------------------------------------------------------------------
-------------------------------------------------------------------------------------------------------------------
-- 
-------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------------------------------------------------------------------*/
class Scene extends React.Component {
    /*-------------------------------------------------------------------------------------------------------------
    -- 
    -------------------------------------------------------------------------------------------------------------*/    
    componentDidMount() {
        this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);

        //var f_name = "data/meshes/Apple/Apple_pc"
        //SystemConfiguration.mesh_out = <Mesh file_name={f_name}></Mesh>
        //SystemConfiguration.mesh_out = <PointCloud file_name={f_name}></PointCloud>
    }
    /*-------------------------------------------------------------------------------------------------------------
    -- 
    -------------------------------------------------------------------------------------------------------------*/
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    /*-------------------------------------------------------------------------------------------------------------
    -- 
    -------------------------------------------------------------------------------------------------------------*/
    render() {
        return(
        <group> {SystemConfiguration.mesh_out}</group>
        
    );}
}


function Loader() {
    const { progress } = useProgress()
    console.log("FUCK")
    console.log(progress)
    //return <Html center>{progress} % loaded</Html>
  }
/*-----------------------------------------------------------------------------------------------------------------
-------------------------------------------------------------------------------------------------------------------
-- 
-------------------------------------------------------------------------------------------------------------------
-----------------------------------------------------------------------------------------------------------------*/
class Renderer extends React.Component {
    constructor(props) {
      super(props);
      this.state = {render: true};
    }



    // componentDidMount() {
    //     this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
    // }

    render() {
        var sceneee = <Scene/>
        // SystemConfiguration.perspeciveCamera = <PerspectiveCamera position={[2, 2, 2]} makeDefault />
        
        return (
            <div id='renderersrc_main'>
                <div id="renderersrc_view">
                    <div id="renderersrc_image"><img id="renderersrc_image_inner"/></div>
                    <Canvas id='Renderer_renderer_canvas' linear={false}>
                        <ambientLight intensity={1.0} color={"#ffffff"}/>
                        <PerspectiveCamera position={[2, 2, 2]} makeDefault>
                        {/* <directionalLight position={[2, 2, 2]} color="#FFFFFF" intensity={0.0} /> */}
                        </PerspectiveCamera>  
                        <OrbitControls />
                        <gridHelper args={[100,100, 0x555555, 0x555555]}/>

                        {/* <Particles pointCount={25}/> */}

                        {/* <EffectComposer>
                        <DepthOfField
                            focusDistance={0} // where to focus
                            focalLength={0.02} // focal length
                            bokehScale={1} // bokeh size
                        />
                        </EffectComposer> */}

                        <Suspense fallback={null}>
                            {/* <PointCloud file_path={process.env.PUBLIC_URL + '/' + "data/Wappentier_blue.ply"}/> */}
                            {sceneee}
                            {/* <PointCloud/> */}
                        </Suspense>
                    </Canvas>
                </div>
            </div>
        );
    }
  }

export default Renderer;